import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { StatusTrackerContext } from './context.es.js';

const StatusTrackProvider = ({ children, ...rest })=>{
    const values = useMemo(()=>({
            ...rest
        }), [
        rest
    ]);
    return jsx(StatusTrackerContext.Provider, {
        value: values,
        children: children
    });
};
StatusTrackProvider.displayName = 'StatusTrackProvider';

export { StatusTrackProvider };
//# sourceMappingURL=provider.es.js.map
